import { ValueOf } from '../utilities/types';
import productTypes, { ProductTypes } from './productTypes';

const productPartyRoles = {
  PRODUCT_HOLDER: 'product-holder',
  CONNECTED_ACCOUNT: 'connected-account',
  ISSUER: 'issuer',
  DEBTOR: 'debtor',
} as const;
export type ProductPartyRoles = ValueOf<typeof productPartyRoles>;

const productPartyRolesLabels: Record<ProductPartyRoles, string> = {
  [productPartyRoles.PRODUCT_HOLDER]: 'Product holder',
  [productPartyRoles.CONNECTED_ACCOUNT]: 'Connected account',
  [productPartyRoles.ISSUER]: 'Issuer',
  [productPartyRoles.DEBTOR]: 'Debtor',
};

const allowedPartyRoles = {
  [productTypes.INVOICE]: [
    productPartyRoles.CONNECTED_ACCOUNT,
    productPartyRoles.ISSUER,
    productPartyRoles.DEBTOR,
    productPartyRoles.PRODUCT_HOLDER,
  ],
  [productTypes.LINE_OF_BUSINESS]: [
    productPartyRoles.CONNECTED_ACCOUNT,
    productPartyRoles.CONNECTED_ACCOUNT,
  ],
  [productTypes.SWISH]: [
    productPartyRoles.CONNECTED_ACCOUNT,
    productPartyRoles.PRODUCT_HOLDER,
  ],
};

export const getProductPartyRolesChoices = (productType: ProductTypes) => (
  allowedPartyRoles[productType].map((role: ProductPartyRoles) => ({
    id: role,
    name: productPartyRolesLabels[role],
  }))
);

export const displayProductPartyRolesChoices = Object.entries(
  productPartyRolesLabels,
).map(([key, value]) => ({
  id: key,
  name: value,
}));

export default productPartyRoles;
